import { ISettingsLayoutProps } from "./SettingsLayoutTypes"

import { Container, Flex } from "@chakra-ui/react"

import MainLayout from "components/templates/MainLayout"
import CompanyBranches from "components/shared/CompanyBranches"
import Heading from "components/UI/atoms/Heading"
import FeeHistoryModal from "components/shared/modals/FeeHistoryModal"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { useUI } from "providers/UIProvider"

const SettingsLayout: React.FC<ISettingsLayoutProps> = ({ children, title , withCompanyBranches = true }) => {
  const { modals } = useUI()
  const { isAdmin } = useAppContext()

  return (
    <MainLayout navigation>
        <>
        {isAdmin && withCompanyBranches && <CompanyBranches/>}
          <Container 
            mt="20px" 
            maxWidth="100%" 
            padding="22px 28px" 
            bg="white"
            borderRadius="base"
            boxShadow="0px 100px 50px #046CEC0D"
            mb="50px"
          >
            {title && <Heading title={title} variant="regular" /> }

            <Flex w="100%" alignItems="center" flexDirection="column">
              {children}
            </Flex>
          </Container>
          {modals.feeHistoryModal.isOpened && <FeeHistoryModal />}
        </>
    </MainLayout>
  )
}

export default SettingsLayout